import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function Capabilities() {
  const { t } = useLanguage();

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    card.style.setProperty('--mouse-x', `${x}px`);
    card.style.setProperty('--mouse-y', `${y}px`);
  };

  return (
    <section className="section-wrapper reveal-on-scroll" id="yetenekler">
      <div className="container">
        <div className="section-header-neo">
          <div>
            <div className="neo-tag-pill">
              <span>[ {t.ui.capabilitiesLabel} ]</span>
            </div>
            <h2 className="neo-section-title">{t.ui.capabilitiesTitle}</h2>
          </div>
          <p className="neo-section-sub">{t.ui.capabilitiesSubtitle}</p>
        </div>

        {/* 4 Matrix Cards */}
        <div className="capabilities-neo-grid">
          {t.capabilities.map((item, idx) => (
            <div
              key={idx}
              className="capability-neo-card spotlight-card"
              onMouseMove={handleMouseMove}
              style={{ animationDelay: `${idx * 0.12}s` }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #1e222d', paddingBottom: '0.65rem' }}>
                <h3 className="capability-neo-title">{item.title}</h3>
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.8rem', color: 'var(--accent-acid)', fontWeight: 700 }}>
                  [DOM-0{idx + 1}]
                </span>
              </div>

              <p style={{ fontFamily: 'var(--font-mono)', color: 'var(--text-silver)', fontSize: '0.94rem', lineHeight: 1.65 }}>
                {item.description}
              </p>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem', marginTop: 'auto', paddingTop: '0.5rem' }}>
                {item.technologies.map((tech) => (
                  <span
                    key={tech}
                    className="neo-tag-pill tag-spring"
                    style={{ fontSize: '0.76rem', padding: '0.2rem 0.55rem' }}
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Toolbelt Matrix Box */}
        <div className="toolbelt-neo-box reveal-on-scroll">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #282d3b', paddingBottom: '0.75rem' }}>
            <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.15rem', fontWeight: 800, color: '#ffffff' }}>
              [ {t.ui.toolbeltTitle} ]
            </span>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.8rem', color: '#525866' }}>
              {'// FULL_STACK_INVENTORY'}
            </span>
          </div>

          <div className="toolbelt-neo-grid">
            {t.toolbelt.map((col) => (
              <div key={col.category}>
                <div className="toolbelt-neo-col-title">:: {col.category}</div>
                <div>
                  {col.items.map((tech) => (
                    <div key={tech} className="toolbelt-neo-item tag-spring">
                      {tech}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
